module.exports = __webpack_public_path__ + "img/tete.6362c5c9.png";